<template>
  <tr :class="[{'active': active}]">
    <td>
      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="red"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>

      <div
      class="underline-link"
      @click.stop="$root.$timelineNav.open(item.id)">
        RID:
        {{ item.id }}
      </div>

    </td>
    <td class="caption">
      <span v-if="item.batch_number">
        <v-icon small>mdi-barcode</v-icon>
        {{ item.batch_number }}
      </span>
    </td>
    <td>
      {{ item.definition.name }}
    </td>
    <td>

      <span v-if="item.inventory_instance_count === 0">
        ---
      </span>
      <template v-else>
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="item.total_stock"
        :key="item.id"
        alwaysScale
        labelMode
        ></c-ms-ii>
      </template>
    </td>
    <td class="caption">
      <router-link
      v-if="item.production_id"
      class="underline-link d-flex align-center"
      :to="{ path: '/production/' + item.production_id}" @click.native.stop>
        <img class="header-img pa-1" src="@/assets/img/illustrations/production.png" alt="vial" width="30px">
        {{ item.production_id }}
      </router-link>
      <router-link
      v-else-if="item.delivery_id"
      class="underline-link d-flex align-center"
      :to="{ path: '/delivery/' + item.delivery_id}" @click.native.stop>
        <img class="header-img pa-1" src="@/assets/img/illustrations/package.png" alt="package" width="30px">
        {{ item.delivery_id }}
      </router-link>
    </td>
    <td>
      <v-icon color="pink" v-if="item.timeline_error" small>mdi-alert</v-icon>

      <v-icon v-if="item.timeline_match" color="green">mdi-check</v-icon>
      <div v-else>
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue="item.timeline_difference"
        :key="item.id"
        alwaysScale
        labelMode
        class="red--text caption"
        ></c-ms-ii>
      </div>

    </td>
  </tr>
</template>

<script>
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: ['item', 'searchFilters', 'active', 'currentSelection'],
  components: {
    JsonViewer
  },
  data () {
    return {
      
    }
  }
}
</script>